import { LocalityGrid } from 'generated/graphql';

import { getGridRowsAndCols } from './getGridRowsAndCols';

export function getBargePositions(arrangement: LocalityGrid): number[] {
  const { rows, cols } = getGridRowsAndCols(arrangement);
  const maxBargeIndex = 2 * (cols + rows);
  return Array.from(Array(maxBargeIndex).keys());
}
